import { setPageSizeAndPersist, useAppDispatch } from '@salescore/client-redux'

import { useViewStatePageSize, useViewStateViewId } from './useViewState'

export const usePageSizeState = (): [number, (pageSize: number) => void] => {
  const dispatch = useAppDispatch()
  const viewId = useViewStateViewId()
  const pageSize = useViewStatePageSize()

  const setPageSize = (newPageSize: number): void => {
    dispatch(setPageSizeAndPersist({ viewId, pageSize: newPageSize }))
  }

  return [pageSize, setPageSize]
}
